import { useState } from "react";
import { toast } from "sonner";
import { createCheckout } from "@/lib/api";
import { formatPrice, isPurchasable } from "../format";

export default function PDPActions({ piece, onInquire }) {
  const [loading, setLoading] = useState(false);
  const buyable = isPurchasable(piece);

  const acquire = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await createCheckout(piece.slug);
      window.location.href = checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Secure checkout is unavailable. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="border border-[var(--pd-border)] p-7 bg-[#050505]" data-testid="pdp-actions">
      <div className="flex items-baseline justify-between gap-4">
        <span className="eyebrow">{buyable ? "Price" : "Pricing"}</span>
        <span className="font-serif-display text-2xl text-[var(--pd-gold)] tracking-[0.08em]" data-testid="pdp-price">
          {formatPrice(piece)}
        </span>
      </div>
      <div className="mt-3 flex items-baseline justify-between gap-4">
        <span className="eyebrow">Availability</span>
        <span className="font-serif-body text-white/80" data-testid="pdp-availability">{piece.availability}</span>
      </div>

      <div className="mt-7 flex flex-col gap-3">
        {buyable && (
          <button onClick={acquire} disabled={loading} className="btn-gold w-full disabled:opacity-60" data-testid="pdp-acquire-btn">
            <span>{loading ? "Opening secure checkout…" : "Acquire Securely"}</span>
          </button>
        )}
        <button
          onClick={() => onInquire("viewing")}
          className={buyable ? "btn-ghost w-full" : "btn-gold w-full"}
          data-testid="pdp-viewing-btn"
        >
          <span>Request Private Viewing</span>
        </button>
        <button onClick={() => onInquire("pricing")} className="btn-ghost w-full" data-testid="pdp-inquire-btn">
          {buyable ? "Ask the Concierge" : "Inquire About Price & Details"}
        </button>
      </div>
      <p className="mt-5 text-white/35 text-[0.58rem] uppercase tracking-[0.3em] leading-relaxed">
        {buyable
          ? "Payments processed securely by Stripe · Insured private delivery"
          : "A maison concierge replies personally within 72 hours"}
      </p>
    </div>
  );
}
